/** 足行天下 HTTP 请求（对齐 zvkf9s：JSON POST + result/resultNote） - 作者: zbq, 日期: 2026-05-29 */

import { getZqApiBase } from '@/sheep/config/zq';
import { tenantId as defaultTenantId } from '@/sheep/config';
import { clearShopSessionCookies } from '@/sheep/api/zq/share';

/** 获取 H5 请求商家 ID（tenant-id 请求头，优先缓存，其次 .env，默认 1） */
function resolveTenantId() {
  const cached = typeof uni !== 'undefined' ? uni.getStorageSync('tenant-id') : '';
  return String(cached || defaultTenantId || '1');
}

const SESSION_EXPIRED = ['2', '4', '5', '6'];

export function clearZqSession() {
  // 不清理 wxinvite / wxfid：推广码需跨登录会话保留，供下单 shareId 归因
  [
    'id',
    'zq_token',
    'phone',
    'fid',
    'dailishangID',
    'openid',
    'openId',
    'wx_openid',
    'zq_is_merchant',
    'zq_role',
    'member-tenant-id',
  ].forEach((key) => {
    uni.removeStorageSync(key);
  });
  clearShopSessionCookies();
}

export function zqRequest(options = {}) {
  const { url, data = {}, method = 'POST', showLoading = true, modal = false, silent = false } = options;

  if (showLoading) {
    uni.showLoading({ title: '加载中...', mask: true });
  }

  return new Promise((resolve, reject) => {
    uni.request({
      url: `${getZqApiBase()}${url}`,
      method,
      data,
      // 高峰期后端可能排队：默认 15s 超时快速失败（可按接口覆盖），避免遮罩卡死无法取消
      timeout: options.timeout || 15000,
      sslVerify: false,
      header: {
        'Content-Type': 'application/json;charset=UTF-8',
        'tenant-id': resolveTenantId(),
        uid: uni.getStorageSync('id') || '',
        // 有新 invite 时可能已清掉 wxfid；无 invite 时用本地 wxfid 兜底
        shareId: uni.getStorageSync('wxfid') || '',
      },
      success(res) {
        if (showLoading) {
          setTimeout(() => uni.hideLoading(), 100);
        }

        const body = res.data || {};
        const result = body.result != null ? String(body.result) : '';
        const msg = body.resultNote || body.msg || '网络请求失败';
        const bizCode = body.code;

        // 缓存了已删除商家 ID（如旧 172）时接口报商家不存在 → 回退平台店并提示刷新
        if (
          bizCode === 1002900180
          || (typeof msg === 'string' && (msg.includes('商家不存在') || msg.includes('商家已禁用') || msg.includes('商家已过期')))
        ) {
          const bad = resolveTenantId();
          if (bad && bad !== '1') {
            uni.setStorageSync('tenant-id', '1');
            uni.showToast({ title: '店铺已更新，请重新进入', icon: 'none' });
            setTimeout(() => {
              // #ifdef H5
              if (typeof window !== 'undefined') {
                const u = new URL(window.location.href);
                u.searchParams.delete('tenantId');
                window.location.replace(u.toString());
                return;
              }
              // #endif
              uni.reLaunch({ url: '/pages/home/login' });
            }, 800);
          }
          reject({ code: -1, msg, data: body });
          return;
        }

        if (res.statusCode !== 200) {
          const err = { code: -1, msg, data: null };
          showZqError(msg, modal, silent);
          reject(err);
          return;
        }

        if (result === '0' || result === '3') {
          resolve({
            code: 0,
            msg,
            data: body,
            needVerify: result === '3',
          });
          return;
        }

        if (SESSION_EXPIRED.includes(result)) {
          clearZqSession();
          uni.showToast({ title: msg, icon: 'none' });
          setTimeout(() => uni.reLaunch({ url: '/pages/home/login' }), 1500);
          reject({ code: -1, msg, data: null });
          return;
        }

        const err = { code: -1, msg, data: body };
        showZqError(msg, modal, silent);
        reject(err);
      },
      fail(err) {
        if (showLoading) {
          setTimeout(() => uni.hideLoading(), 100);
        }
        // 网络层失败（超时/断网/被拦截）统一归为「网络不可达」，不暴露 request:fail 这类原始串；
        // silent 时交给调用方自行渲染错误态（详情页会显示「网络不可达」并隐藏购买入口）
        const msg = /timeout|超时/.test(String(err.errMsg || ''))
          ? '请求超时，网络不可达'
          : '网络不可达，请稍后重试';
        if (!silent) {
          uni.showToast({ title: msg, icon: 'none' });
        }
        reject({ code: -1, msg, data: null });
      },
    });
  });
}

function showZqError(msg, modal, silent) {
  // silent：由调用方自行渲染错误态（如方案详情页「已下架」占位），不再弹全局提示
  if (silent) {
    return;
  }
  if (modal) {
    uni.showModal({
      title: '提示',
      content: msg || '操作失败',
      showCancel: false,
      confirmColor: '#F00202',
    });
    return;
  }
  uni.showToast({ title: msg || '操作失败', icon: 'none' });
}
